package com.ijoin.data.repository

import com.ijoin.data.api.PaymentApi
import com.ijoin.data.model.CreatePaymentIntentRequest
import com.ijoin.data.model.CreatePaymentIntentResponse

class PaymentRepository(
    private val paymentApi: PaymentApi = PaymentApi(),
) {
    suspend fun createPaymentIntent(
        request: CreatePaymentIntentRequest,
    ): Result<CreatePaymentIntentResponse> {
        return paymentApi.createPaymentIntent(request)
    }
}
